import { api } from 'api/api';
import { urls } from 'api/urls';

const finalizarOnBoarding = async () => await api.post(`${urls.finalizarOnBoarding}`, undefined);

export { finalizarOnBoarding };
